import { useState, useEffect, useCallback } from "react";
import { Carousel } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getFirestore } from "../../config/firebase";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import Loading from "../Loading/Loading";

const Slider = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { openConsultaForm } = useWhatsAppConsulta();

  const handleSlideClick = useCallback(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "solicitud_presupuesto", origen: "slider" });
    openConsultaForm();
  }, [openConsultaForm]);

  const renderSlide = (item, index) => (
    <Carousel.Item key={index}>
      <img
        className="d-block w-100 img-fluid"
        src={item.slider}
        alt="Montironi Hyundai"
        onClick={handleSlideClick}
        style={{ cursor: "pointer" }}
      />
    </Carousel.Item>
  );

  useEffect(() => {
    const obtenerDatos = async () => {
      const datosLocales = sessionStorage.getItem("sliders-hyundai");
      if (datosLocales) {
        setBanners(JSON.parse(datosLocales));
        setLoading(false);
      } else {
        const db = getFirestore();
        try {
          const data = await db.collection("sliders-hyundai").get();
          const arrayData = data.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          sessionStorage.setItem("sliders-hyundai", JSON.stringify(arrayData));
          setBanners(arrayData);
        } catch (error) {
          console.error("Error al obtener datos de Firestore: ", error);
        } finally {
          setLoading(false);
        }
      }
    };

    obtenerDatos();
  }, []);

  const routeTipo = location.pathname.split("/").pop();

  return loading ? (
    <Loading styles="mt-5 pt-5 pb-5" />
  ) : (
    <div id="inicio">
      {routeTipo === "todos" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] && banners[0].desktop.map((item, index) => renderSlide(item, index))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] && banners[0].mobile.map((item, index) => renderSlide(item, index))}
            </Carousel>
          </div>
        </>
      )}
      {routeTipo === "plan" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] && banners[0].desktop.filter((b) => b.plan === true).length > 0
                ? banners[0].desktop.filter((b) => b.plan === true).map((item, index) => renderSlide(item, index))
                : banners[0] && banners[0].desktop.map((item, index) => renderSlide(item, index))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] && banners[0].mobile.filter((b) => b.plan === true).length > 0
                ? banners[0].mobile.filter((b) => b.plan === true).map((item, index) => renderSlide(item, index))
                : banners[0] && banners[0].mobile.map((item, index) => renderSlide(item, index))}
            </Carousel>
          </div>
        </>
      )}
      {routeTipo === "convencional" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] && banners[0].desktop.filter((b) => b.convencional === true).length > 0
                ? banners[0].desktop
                    .filter((b) => b.convencional === true)
                    .map((item, index) => renderSlide(item, index))
                : banners[0] && banners[0].desktop.map((item, index) => renderSlide(item, index))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] && banners[0].mobile.filter((b) => b.convencional === true).length > 0
                ? banners[0].mobile
                    .filter((b) => b.convencional === true)
                    .map((item, index) => renderSlide(item, index))
                : banners[0] && banners[0].mobile.map((item, index) => renderSlide(item, index))}
            </Carousel>
          </div>
        </>
      )}
    </div>
  );
};

export default Slider;
